import { goBack } from "connected-react-router";
import { call, put, select, takeLatest, takeLeading } from "redux-saga/effects";
import {
  getLombardPortId,
  getLombardPortIdSuccess,
  getLombardPortIdFailure,
  getLombardTransactions,
  getLombardTransactionsSuccess,
  getLombardTransactionsFailure,
} from "redux/reducers/lombard";
import { LomBardSelector } from "redux/selector/lombard";
import { LombardAPI } from "services/lombard";

function* getLombardPortIdSaga() {
  try {
    const response = yield call(LombardAPI.getLombardPortId);
    const portInfo = response.data.result;
    yield put(getLombardPortIdSuccess(portInfo));
  } catch (error) {
    yield put(getLombardPortIdFailure(error));
    yield put(goBack());
  }
}

function* getLombardTransactionsSaga() {
  try {
    const [startDate, endDate] = yield select(LomBardSelector.filterTransactionDate);
    const params = {
      startDate: startDate?.format("YYYY-MM-DD"),
      endDate: endDate?.format("YYYY-MM-DD"),
    };
    const response = yield call(LombardAPI.getLombardTransactions, params);
    const transactions = response.data.result?.transaction ?? [];
    const numberOfPendingTrans = response.data.result?.badge;
    yield put(getLombardTransactionsSuccess({ transactions, numberOfPendingTrans }));
  } catch (error) {
    yield put(getLombardTransactionsFailure(error));
  }
}

const saga = [
  takeLeading(getLombardPortId.type, getLombardPortIdSaga),
  takeLatest(getLombardTransactions.type, getLombardTransactionsSaga),
];

export default saga;
